export const LOAD_REQUESTED = "DASHBOARD_WIDGET/LOAD_REQUESTED";
export const LOAD_SUCCESS = "DASHBOARD_WIDGET/LOAD_SUCCESS";
export const LOAD_FAIL = "DASHBOARD_WIDGET/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoaddashboardWidget = data => ({ type: LOAD_REQUESTED, data });
export const successLoaddashboardWidget = data => ({ type: LOAD_SUCCESS, data });
export const failLoaddashboardWidget = data => ({ type: LOAD_FAIL, data });
